"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var FormContext_1 = require("./FormContext");
var FieldsContainer = function (_a) {
    var children = _a.children, setFields = _a.setFields, isSubmit = _a.isSubmit, textValidation = _a.textValidation;
    var _b = React.useContext(FormContext_1.ValidationsContext), setSubmitted = _b.setSubmitted, formFields = _b.formFields, setTextValidation = _b.setTextValidation;
    React.useEffect(function () {
        setFields(formFields);
    }, [formFields]);
    React.useEffect(function () {
        setSubmitted(isSubmit);
    }, [isSubmit]);
    React.useEffect(function () {
        setTextValidation(textValidation);
    }, [setTextValidation, textValidation]);
    return React.createElement(React.Fragment, null, children);
};
exports.default = FieldsContainer;
//# sourceMappingURL=FieldsContainer.js.map